import { Menu } from "@headlessui/react";

type DropdownMenuItemProps = {
    children: React.ReactNode;
};

const DropdownMenuItem = ({ children }: DropdownMenuItemProps) => {
    return <Menu.Item>{children}</Menu.Item>;
};

export default DropdownMenuItem;
